"use strict";

const IddeRoutes = function () {
  const MuniOutfallFactSheetController = require("../../muni/muniOutfallFactSheetController");
  const MuniHardAssetFactSheetController = require("../../muni/muniHardAssetFactSheetController");
  const MuniCatchBasinFactSheetController = require("../../muni/muniCatchBasinFactSheetController");
  const IncidentFactSheetController = require("../../illicitDischarge/incidents/incidentFactSheetController");
  const CompositeAssetId = require("../../general/compositeAssetId");

  const factSheetRoute = {
    as: "idde-fact-sheet",
    handler: function ({ data, hashString }) {
      const options = { highlightId: hashString, compositeId: data.id };
      const { assetType, id } = CompositeAssetId.parse(data.id);
      if (assetType === "outfall") {
        MuniOutfallFactSheetController.open(id, options);
      } else if (assetType === "manhole") {
        MuniHardAssetFactSheetController.open("manhole", id, options);
      } else if (assetType === "bmpFcs") {
        MuniCatchBasinFactSheetController.open(id, options);
      } else {
        throw new Error(`Unknown asset type for IDDE fact sheet: ${assetType}`);
      }
    },
    data: { dataView: "dry-weather" },
  };

  const incidentFactSheetRoute = {
    as: "incident-fact-sheet",
    handler: function ({ data, hashString }) {
      IncidentFactSheetController.open(data.id, { highlightId: hashString });
    },
  };

  const incidentFactSheetHighlightRoute = {
    as: "incident-fact-sheet-highlight",
    handler: incidentFactSheetRoute.handler,
  };

  return {
    factSheetRoute,
    incidentFactSheetRoute,
    incidentFactSheetHighlightRoute,
  };
};

module.exports = IddeRoutes();
